import { __awaiter, __generator, __read } from "tslib";
import { WORKSPACE_ID } from '@office-start/app-gallery-types';
import { useCapabilities } from '@office-start/capabilities-service';
import { aadAppPlatformType, useAppBarUserData, useDefaultHubApps, } from '@office-start/data-resolver-app-pinning';
import { getErrorHandler } from '@office-start/error-handler';
import { fetchWorkspaces, } from '@office-start/workspaces-service';
import * as React from 'react';
import { sanitizeImageUrl } from './utils';
function getAppId(app) {
    if (app.isMicrosoftFirstParty) {
        // We want to retrieve the "Mail" part from "OfficeFirstParty|Mail".
        return app.id.replace('OfficeFirstParty|', '');
    }
    return app.servicePrincipalId || '';
}
function getPlatformType(providerType) {
    var platformType;
    switch (providerType) {
        case 'AzureADThirdParty':
            platformType = aadAppPlatformType;
            break;
    }
    return platformType;
}
/**
 * Custom React Hook responsible for resolving workspaces tile data
 */
export function useWorkspacesTileData() {
    var _this = this;
    var capabilities = useCapabilities().data;
    var defaultApps = useDefaultHubApps();
    var _a = __read(useAppBarUserData(), 1), userData = _a[0];
    var _b = __read(React.useState([]), 2), tileData = _b[0], setTileData = _b[1];
    var defaultAppIds = React.useMemo(function () { return defaultApps === null || defaultApps === void 0 ? void 0 : defaultApps.map(function (app) { return app.id; }); }, [defaultApps]);
    React.useEffect(function () {
        var isSubscribed = true;
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var workspaces, allAppsWorkspace, edges;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!((capabilities === null || capabilities === void 0 ? void 0 : capabilities.appBarOverflowOnlyEnabled) &&
                            defaultAppIds &&
                            ((_a = userData === null || userData === void 0 ? void 0 : userData.pinnedApps) === null || _a === void 0 ? void 0 : _a.some(function (_a) {
                                var id = _a.id, platformType = _a.platformType;
                                // We should only call the Workspaces API if there exists a pinned app that meets one the following conditions:
                                // • Is a first party app that is not present in the default apps
                                // • Is an AAD app
                                return (!platformType && !defaultAppIds.includes(id)) ||
                                    platformType === aadAppPlatformType;
                            })))) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchWorkspaces()];
                    case 1:
                        workspaces = _d.sent();
                        allAppsWorkspace = (_c = (_b = workspaces === null || workspaces === void 0 ? void 0 : workspaces.result) === null || _b === void 0 ? void 0 : _b.workspaces) === null || _c === void 0 ? void 0 : _c.find(function (workspace) { return workspace.id === WORKSPACE_ID.allApps; });
                        edges = allAppsWorkspace === null || allAppsWorkspace === void 0 ? void 0 : allAppsWorkspace.apps.filter(function (app) {
                            // Skip first party apps taken care of by the useHubTileData() hook.
                            return app.isMicrosoftFirstParty &&
                                defaultAppIds.includes(getAppId(app))
                                ? false
                                : true;
                        }).map(function (app) {
                            // Add the workload as a new edge.
                            var platformType = getPlatformType(app.providerType);
                            return {
                                node: {
                                    id: getAppId(app),
                                    name: app.displayName,
                                    accessibleName: app.displayName,
                                    platformType: platformType,
                                    icon: {
                                        __typename: 'RemoteImage',
                                        src: sanitizeImageUrl(app.logoUrl),
                                        isFullBleed: platformType != null, // only non-first-party icons support full bleed
                                    },
                                    brandingColor: app.fontColor || '',
                                    isPinnable: true,
                                    enablePlatformCommands: false,
                                    lockedIndex: undefined,
                                    pinnedIndex: undefined,
                                    canLaunchOut: true,
                                    isInUse: false,
                                    anchoredIndex: undefined,
                                },
                            };
                        });
                        if (isSubscribed && edges) {
                            setTileData(edges);
                        }
                        _d.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        fetchData().catch(function (error) {
            getErrorHandler().handleError(error);
        });
        return function () {
            isSubscribed = false;
        };
    }, [capabilities, defaultAppIds, userData]);
    return tileData;
}
//# sourceMappingURL=useWorkspacesTileData.js.map